import { useAuth } from 'react-oidc-context';
import {
  OrderStatusCode,
  RetryShipmentButtonProps,
} from '../interface/interface';

export function RetryShipmentButton({
  currentOrderStatus,

  failureReason,
  hasDeletedShipment,
  handleModalClick,
}: RetryShipmentButtonProps) {
  const { user } = useAuth();
  const addressValidationError = 'Address validation failed';

  if (!user?.access_token) return <></>;

  if (
    ![
      OrderStatusCode.DISPENSED,
      OrderStatusCode.READY_FOR_SHIPPING,
      OrderStatusCode.AUSPOST_FAILURE,
      OrderStatusCode.PARCEL_RETURNED,
    ].includes(currentOrderStatus!) ||
    ([OrderStatusCode.DISPENSED, OrderStatusCode.READY_FOR_SHIPPING].includes(
      currentOrderStatus!,
    ) &&
      !hasDeletedShipment) ||
    (currentOrderStatus === OrderStatusCode.AUSPOST_FAILURE &&
      failureReason === addressValidationError) ||
    !(
      currentOrderStatus === OrderStatusCode.PARCEL_RETURNED &&
      hasDeletedShipment
    )
  )
    return <></>;

  return (
    <button
      className="bg-secondary-green-100 text-primary-blue-500 p-3 
                2.5xl:px-6 2.5xl:py-3 text-sm 2.5xl:text-base font-semibold rounded mr-6"
      onClick={() => handleModalClick()}
    >
      {hasDeletedShipment ? 'Create' : 'Retry'} Shipment
    </button>
  );
}
